export default __webpack_public_path__ + "static/media/omocom.4064f2af.png";